// Re-export all validation utilities from a central location
export * from './shared';
export * from './booking';
export * from './organization';

// Provide convenient grouped exports for different use cases
export { 
  validateEmail, 
  validatePhone, 
  validateAddress,
  validateBillingAddress,
  validateWebsiteUrl,
  validateName,
  validateDescription,
  validateTags,
  validateStatus,
  createValidationResponse,
  checkDuplicateName,
  validateYear,
  validatePositiveNumber,
  validateTimeFormat,
  validateTimeRange,
  validateDateFormat
} from './shared';

export {
  isSlotPotentiallyBookableByUser,
  validateBookingConflicts
} from './booking';

export {
  organizationSchema
} from './organization';

// Type exports
export type { ValidationResult, Address, BillingAddress } from './shared'; 
